"use client";

import { z } from "zod";

export const productCategoryFormSchema = z.object({
  name: z.string().min(1, { message: "Required" }),
  description: z.string().optional(),
});

export const productSubCategoryFormSchema = z.object({
  name: z.string().min(1, { message: "Required" }),
  color: z.string().min(1, { message: "Required" }),
});
